import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { black, ButtonBrand, gold, white } from '../../../getLPTheme';
import Container from '@mui/material/Container';
import { Collapse, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { jwtDecode } from 'jwt-decode'; 
import { options } from '@config';
import Loading from '../../../auxiliares/loading';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';

export interface JwtPayload {
  role: string;
}

export default function ResetPassword() {
  const params = useParams();
  const paperStyle = { height: '70vh', width: 300 };
  const btnstyle = { margin: '8px 0' };

  const [openProgress, setopenProgress] = React.useState(false);
  const [openOptions, setopenOptions] = React.useState(true);
  const [showPassword, setShowPassword] = React.useState(false);
  const [user, setUser] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => { event.preventDefault(); };


  const handleNewPassword = async () => {
    setopenOptions(false)
    setopenProgress(true)

    try {
      
      if (password !== confirmPassword) {
        setError("Las contraseñas no coinciden");
        setopenProgress(false);
        setopenOptions(true);
        return;
      }
      
      const response = await fetch((options.api.url + "newpass" + `?user=${params.user}` + `&token=${params.token}`), {
        method: 'PUT',
        mode: "cors",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setopenProgress(false)
        setopenOptions(true)
        setError(errorData.error);
        return;
      }

      if (response.status === 200) {
          setopenProgress(false)
          swal("Éxito", "Registro exitoso", "success").then(() => {
              navigate('/login');
          });
      } else {
          setopenProgress(false)
          swal("Error", "Hubo un error al cambiar la contraseña", "error");
      }


      const result = await response.json();
      console.log("result",result)
      const token = result.token
      const decodedToken = jwtDecode(token);

      localStorage.setItem('CLUB-VIP-JWT', token);
      localStorage.setItem('CLUB-VIP-AVATAR', decodedToken?.avatar);
      localStorage.setItem('CLUB-VIP-USER', decodedToken?.user);

      if(decodedToken?.role == "admin"){
        navigate('/admin');
      }else{
        navigate('/user');
      }
    } catch (error) {
      setopenProgress(false)
      setError('Error al cambiar la contraseña. Por favor, intenta nuevamente.');
    }
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: { xs: 10, sm: 12 },
        pb: { xs: 4, sm: 6 },
      }}
    >
      <Box
        sx={{
          borderRadius: 1,
          bgcolor: black[900],
          display: 'grid',
          gridTemplateColumns: { md: '1fr 1fr' },
          width: 300,
          height: 'auto',
          direction: "column",
          justifyContent: "center",
          alignItems: "center",
          border: 1,
          borderColor: gold[500]
        }}
      >
        <Grid>
          <Paper elevation={24} style={paperStyle}>
            <Box sx={{ padding: 1 }}>
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <Box sx={{pt: 2}}><Avatar sx={{ bgcolor: gold[400], width: 70, height: 70 }}></Avatar></Box>
              </Grid>
              <h2>Restablecer Contraseña</h2>
              <Grid item xs={4}>
                  <Typography color={white[50]}>
                      Ingresa tu Contraseña:
                  </Typography>
              </Grid>
              <TextField
                InputLabelProps={{ shrink: false }}
                margin="dense"
                size="small"
                label=''
                placeholder='Ingresa tu contraseña'
                required
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <Grid item xs={4}>
                  <Typography color={white[50]}>
                      Repetí tu Contraseña:
                  </Typography>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  margin="dense"
                  size="small"
                  placeholder='Repetí tu contraseña'
                  required
                  sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              {error && <Typography color="#e89b9b">{error}</Typography>}
              <ButtonBrand
                type='submit'
                fullWidth
                onClick={handleNewPassword}
                sx={{mt:2, mb:2}}
              >
                Confirmar
              </ButtonBrand>
              <Collapse in={openProgress}>
                  <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                      <Loading/>
                  </Box>
              </Collapse>
            </Box>
          </Paper>
        </Grid>
      </Box>
    </Container>
  );
}